'use strict';

class SearchField extends HTMLInputElement {
    constructor() {
        super();
        this.endPoint = this.getAttribute('endPoint');
        this.minimumCharacters = this.getAttribute('minimum-characters') || 3;
        this.previousValue = null;

        this.addEventListener('keyup', this.onKeyUp);
        this.addEventListener('blur', this.onBlur);
    }

    onKeyUp() {
        if (this.value === this.previousValue) return;

        this.previousValue = this.value;

        if (this.value.length >= this.minimumCharacters) {
            fetch(`${this.endPoint}?q=${this.value}`)
                .then((response) => response.json())
                .then((response) => this.onSuccess(response))
                .catch((response) => this.onSuccess(response));
        }
    }

    onBlur(evt) {
        // Allow anchors to be clicked || tabbed
        if (!evt.relatedTarget || (evt.relatedTarget && evt.relatedTarget.nodeName !== 'A')) {
            // Add delay to allow link navigation to complete before clearing suggestions
            setTimeout(() => {
                this.dispatchEvent(
                    new CustomEvent('vz-search:results', {
                        detail: []
                    })
                );
            }, 50);
        }
    }

    onSuccess(response) {
        if (response && response.suggestions && response.suggestions.length > 0) {
            this.dispatchEvent(
                new CustomEvent('vz-search:results', {
                    detail: response.suggestions
                })
            );
        }
    }

    onError() {
        this.dispatchEvent(
            new CustomEvent('vz-search:results', {
                detail: []
            })
        );
    }
}

export default SearchField;

customElements.define('vz-search-field', SearchField, { extends: 'input' });
